import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterRacer'
})
export class FilterRacerPipe implements PipeTransform {

  transform(value: any[], by?: string): any {

    if(by === undefined || by === "all"){
      return value
    }
    if(by === 'paid') {
      return value.filter(v => v.paid);
    }
    return value.filter(v => !v.paid);
  }

}
